import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FieldText, FormProps, ClosedContentProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {StatusActiveComp__h5_style} from "core/components/buttons/statusActiveComp";
import {Party, PARTYROLE} from "party/partyDomain";
import {observer} from "mobx-react";
import {PartyActiveComp} from "party/component/partyActiveComp";
import mdEntityService from "core/metamodel/mdEntityService";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import securityService from "core/security/securityService";
import {RESTRICTION} from "core/security/securityDomain";


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<Party>) => (
  <div>

    <div style={{display: 'flex'}}>
      { disabled ? null : <PartyActiveComp partyObject={dataObject} entity={entity} partyCategoryEntity={mdEntityService.getEntity("PARTYCATEGORY")}/>}
      <h5 style={StatusActiveComp__h5_style}> {[dataObject.titleBefore, dataObject.fullName].filter(v=>v).join(' ')} </h5>
    </div>


    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.dateOfBirth.textLabel} value={dataObject.dateOfBirth} mdField={fields.dateOfBirth.mdField} />
      <ClosedFormField label={fields.birthNumber.textLabel} value={dataObject.birthNumber}/>
      <ClosedFormField label={fields.gender.textLabel} value={dataObject.gender}/>
      <ClosedFormField label={fields.birthLastName.textLabel} value={dataObject.birthLastName}/>
      <ClosedFormField label={fields.salutation.textLabel} value={dataObject.salutation}/>
      <ClosedFormField label={fields.placeOfBirth.textLabel} value={dataObject.placeOfBirth}/>
      <ClosedFormField label={fields.nationality.textLabel} value={dataObject.nationality}/>
      <ClosedFormField label={fields.taxDomicile.textLabel} value={dataObject.taxDomicile}/>
      <ClosedFormField label={fields.defaultProfitCenter.textLabel} value={dataObject.defaultProfitCenter}/>
      <ClosedFormField label={fields.hrNumber.textLabel} value={dataObject.hrNumber}/>
    </ClosedFormBlock>


  </div>
);


@createForm({
  formName: 'PartyFoForm',
  fields: [{
    name: 'firstName'
  }, {
    name: 'lastName',
    validators: ['IsRequired']
  }, {
    name: 'titleBefore'
  }, {
    name: 'dateOfBirth'
  }, {
    name: 'birthNumber'
  }, {
    name: 'gender'
  }, {
    name: 'birthLastName'
  }, {
    name: 'salutation'
  }, {
    name: 'placeOfBirth'
  }, {
    name: 'nationality'
  }, {
    name: 'taxDomicile'
  }, {
    name: 'fullName'
  }, {
    name: 'defaultProfitCenter'
  }, {
    name: 'hrNumber'
  }],
  onCommit(dataObject) {
    dataObject.fullName = [dataObject.firstName, dataObject.lastName].filter(v=>v).join(' ');
  }
}, ClosedContent)
@observer
export default class PartyFoForm extends React.Component<FormProps<Party, Party>, undefined> {


  render() {

    let {dataObject, rootObject, entities, entity, open, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {firstName, lastName, titleBefore, dateOfBirth, birthNumber, birthLastName, salutation, placeOfBirth, nationality, taxDomicile,
      gender, defaultProfitCenter, hrNumber} = fields;

    let defaultProfitCenterOptions = (securityService.currentUser.hasRestriction(RESTRICTION.LIMIT_PARTY_BY_USER_PROFITCENTER)) ?
      defaultProfitCenter.props.options.filter(lv => securityService.restrictionData.userProfitCenterIds.includes(lv.value)) : defaultProfitCenter.props.options;


    let openContent = (
      <div>

        {/*  1. row  */}
        <div className="row">
          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...firstName.props} />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <MdTextField  {...lastName.props}/>
            <Validate field={lastName} value={lastName.props.value}/>
          </div>
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...titleBefore.props} />
            </div>
        </div>

        {/*  3. 4. 6. row  */}
        <div className="row">
          <div className="fx col-xs-6 col-sm-4">
            <StyledDatePicker {...dateOfBirth.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...birthNumber.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...gender.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...birthLastName.props}  />
          </div>

          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...salutation.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <MdTextField {...placeOfBirth.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...nationality.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...taxDomicile.props} />
          </div>
          { (dataObject.hasRole(PARTYROLE.USER_ROLE)) ? (
            <div className="fx col-xs-6 col-sm-4">
              <StyledSelect {...defaultProfitCenter.props} options={defaultProfitCenterOptions} />
            </div>
            ) : null
          }
          { (dataObject.hasRole(PARTYROLE.EMPLOYEE)) ? (
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...hrNumber.props} />
            </div>
          ) : null
          }
        </div>

      </div>
    );


    return (open) ? openContent : (
      <BlockComp  noPadding>
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}




// WEBPACK FOOTER //
// ./src/party/component/partyFoForm.tsx